import React, { useContext } from 'react';

import { sendGAEvent } from '@utils/google-analytics';

import { MapContext } from '@contexts/map-context/map-context';

import { TileTypeButton } from '@atlas/atoms/tile-type-button';

import classes from './desktop-tile-type-button.module.scss';

export const DesktopTileTypeButton = () => {
  const { satellite, setSatellite } = useContext(MapContext);

  return (
    <TileTypeButton
      satellite={!satellite}
      onClick={() => {
        setSatellite(!satellite);
        !satellite && sendGAEvent('atlas_map', 'click', 'satelitni');
      }}
      className={classes.button}
    />
  );
};
